import AddToCartStickyFooterView from './views/sticky-footer.js';
import AddToCartView from './views/add-to-cart.js';

export default class AddToCart {
	constructor({
		el,
		product_id,
		cart_product,
		in_stock_qty,
		allow_duplicates,
		show_popup,
		adv_source,
		map_policy,
		variations,
		sticky_footer,
		track_ga_events,
		is_accessory,
		cart_modal_placeholder,
		options_active
	}) {
		this.view = new AddToCartView({
			el: el,
			product_id: product_id,
			cart_product: cart_product,
			in_stock_qty: in_stock_qty,
			allow_duplicates: allow_duplicates,
			show_popup: show_popup,
			adv_source: adv_source,
			map_policy: map_policy,
			variations: variations,
			track_ga_events: track_ga_events,
			is_accessory: is_accessory,
			cart_modal_placeholder: cart_modal_placeholder,
			options_active: options_active
		});

		if (typeof sticky_footer !== 'undefined') {
			this.sticky_footer_view = new AddToCartStickyFooterView({
				el: sticky_footer,
				add_to_cart_el: el,
				cart_product: cart_product,
				allow_duplicates: allow_duplicates,
				is_accessory: is_accessory
			});
		}
	}
}